import React, { useEffect, useState } from "react";
import { dummyContactsData } from "contains/contants";

import sendMessage from "images/send_message.svg";
import { useLocation } from "react-router-dom";
import { useMyContext } from "context/footerContext";

import AddIcon from "@mui/icons-material/Add";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";

const AccountMessenger = () => {
  const location = useLocation();
  const [contactData, setContactData] = useState(dummyContactsData);
  const [selectedContactIndex, setSelectedContactIndex] = useState(0);

  const { setValidFooter } = useMyContext();

  useEffect(() => {
    setValidFooter(location.pathname);

    return () => {
      setValidFooter("");
    };
  }, []);

  return (
    <div className="messengerContainer">
      <div className="contactsContainer">
        <div className="contactsContainer_search">
          <input placeholder="Search in contacts" />
        </div>
        <div className="contactCardContainer">
          {contactData?.map((cont, index) => {
            return (
              <div
                role="banner"
                onClick={() => setSelectedContactIndex(index)}
                className={
                  selectedContactIndex === index
                    ? "contactCardSelected"
                    : "contactCard"
                }
                key={cont?.date}
              >
                <div className="contactCard_image" />
                <div className="contactCard_text_container">
                  <div className="nameAndDate">
                    <span className="contactCard_title">{`${cont?.name} ${cont.surname}`}</span>
                    <span>{`${cont?.date}`}</span>
                  </div>
                  <span>{`${cont?.message}`}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="chattingContainer">
        <div className="header">
          <div className="header_image" />
          <div className="contact_info">
            <span className="title">{`${contactData[selectedContactIndex]?.name}  ${contactData[selectedContactIndex]?.surname}`}</span>
            <span>{`${contactData[selectedContactIndex]?.role}`}</span>
          </div>
        </div>
        <div className="chat_messages">
          {contactData[selectedContactIndex]?.messages.map((va: any) => {
            return (
              <div className={va.receiver ? "receiver" : "sender"}>
                <div className={"message"}>
                  <span>{va.message}</span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="messageBox">
          <AddIcon sx={{ color: "#4bc265", cursor: "pointer" }} />
          <div className="messageInput">
            <input placeholder="Enter Message" />
            <img alt="send" src={`${sendMessage}`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountMessenger;
